module.exports = __webpack_public_path__ + "img/confetti.11ba127.svg?v=1744194310396";